import React, { forwardRef, useEffect, useImperativeHandle, useRef, useState } from 'react';
import dayjs from 'dayjs';
import { ArrowUpRight } from 'lucide-react';
import { previewRefresh } from '../Dashboard/hooks/usePreview';

const designWidth = 1920;
const designHeight = 1080;

const dashboardPath = () => {
  const now = dayjs();
  return `/dashboard/${now.month() + 1}/${now.year()}`;
};

const dashboardSrc = () => `${dashboardPath()}?preview=1`;

const LiveTv = forwardRef((props, ref) => {
  const frameRef = useRef(null);
  const boxRef = useRef(null);
  const [width, setWidth] = useState(0);
  const [src] = useState(dashboardSrc);

  useEffect(() => {
    const box = boxRef.current;
    if (!box) return undefined;
    const observer = new ResizeObserver(([entry]) => setWidth(entry.contentRect.width));
    observer.observe(box);
    return () => observer.disconnect();
  }, []);

  useImperativeHandle(
    ref,
    () => ({
      refresh: () =>
        frameRef.current?.contentWindow?.postMessage({ type: previewRefresh }, window.location.origin),
    }),
    [],
  );

  const scale = width / designWidth;

  return (
    <div className="adm-tv-inner">
      <p className="adm-tv-label">Live op de TV</p>
      <div className="adm-tv-screen" ref={boxRef} style={{ height: width * (designHeight / designWidth) }}>
        {width > 0 && (
          <iframe
            ref={frameRef}
            title="Het dashboard zoals het op de TV staat"
            src={src}
            tabIndex={-1}
            style={{ width: designWidth, height: designHeight, transform: `scale(${scale})` }}
          />
        )}
      </div>
      <p className="adm-tv-note">
        Het echte dashboard, verkleind. Na elke wijziging ververst het meteen en speelt het
        dezelfde animatie als de TV, zonder geluid.
      </p>
      <a className="adm-tv-open" href={dashboardPath()} target="_blank" rel="noreferrer">
        Open het dashboard
        <ArrowUpRight size={16} aria-hidden />
      </a>
    </div>
  );
});

export default LiveTv;
